import { module } from 'modujs';
import { Swiper, Navigation } from 'swiper';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        Swiper.use([Navigation]);

        this.length = this.$('item').length
        this.container = this.$('container')[0];
        this.arrowNext = this.$('next')[0]
        this.arrowPrev = this.$('prev')[0]

        const args = {
            speed: 900,
            loop: true,
            spaceBetween: 0,
            grabCursor: true,
            slidesPerView: 1,
            loopedSlides: 2,
            spaceBetween: 0,
            threshold: 3,
            navigation: {
                prevEl: this.arrowPrev,
                nextEl: this.arrowNext
            },
            breakpoints: {
                1000: {
                    slidesPerView: 2,
                    loopedSlides: 3
                }
            }
        }

        let viewportWidth = window.innerWidth || document.documentElement.clientWidth;

        if (viewportWidth < 1000) {
            if(this.length > 1){
                this.carousel = new Swiper(this.container, args)
                this.arrowPrev.classList.remove('is-hidden')
                this.arrowNext.classList.remove('is-hidden')
            }
        } else {
            if(this.length > 2) {
                this.carousel = new Swiper(this.container, args)
                this.arrowPrev.classList.remove('is-hidden')
                this.arrowNext.classList.remove('is-hidden')
            }
        }
    }

    destroy() {
        if(this.carousel && this.carousel.destroy) this.carousel.destroy()
    }
}
